import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { routes } from "Uitls/Util";
import fallimg from "img/routesfallback.svg";
const RouteUIFallback = () => {
  const history = useHistory();

  const handleGoHome = () => {
    history.push(routes.dashboard || "/dashboard");
  };

  return (
    <Container
      fluid
      className="vh-100 d-flex align-items-center justify-content-center bg-light"
    >
      <Row className="justify-content-center w-100">
        <Col xs={12} md={6} className="text-center">
          <div
            className="d-flex flex-column align-items-center"
            style={{ gap: "19px" }}
          >
            {/* Image */}
            <div className="mb-4">
              <img src={fallimg} alt="404" />
            </div>

            {/* Page / Resource not found (404) text */}
            <div
              className="fw-bold fs-5 text-dark"
              style={{ fontWeight: 700, color: "#000000" }}
            >
              Page / Resource not found (404)
            </div>

            {/* Go to Home link */}
            <div
              className="fs-5 fw-bold cursor-pointer"
              style={{ color: "#2E80C0", fontWeight: 600, cursor: "pointer" }}
              onClick={handleGoHome}
            >
              Go to Home
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default RouteUIFallback;
